import React, { useEffect, useState } from 'react';

// PersonAvatar (role/gender付きの正式版) を使うほど重くない場面向けの、
// 最小の画像フォールバック部品。座席プランナーのステージ上アイコンやタイムテーブルの
// 出演者アイコンなど、「呼び出し側が既に url/頭文字を用意していて、あとは onError で
// 頭文字表示へ落とすだけ」の .map() 内で繰り返し使う。
// 見た目（サイズ/背景色/枠）は呼び出し側の既存コンテナ（例: .stage-seating-avatar）に委ね、
// 本コンポーネントは中身（img もしくは頭文字span）だけを描画する。
export function AvatarImage({ url, initial = '?', ...imgProps }) {
  const [failedUrl, setFailedUrl] = useState('');

  useEffect(() => {
    setFailedUrl('');
  }, [url]);

  const visibleUrl = url && failedUrl !== url ? url : '';

  if (!visibleUrl) {
    return <span>{initial}</span>;
  }

  return (
    <img
      src={visibleUrl}
      alt=""
      draggable={false}
      {...imgProps}
      onError={() => setFailedUrl(visibleUrl)}
    />
  );
}

export default AvatarImage;
